<template>
    <div>
     <div class="notification-panel-wrapper">
         <div class="close-or-min-panel">
             <div class='d-flex'>
                 <div style="text-align:start;padding: 9px;font-size: 24px;">{{$t('Fusion AI Assistant')}}</div>
             </div>
             <div v-on:click="closeAIPanel()" style="display:flex;align-items:center">
                  <cancelIcon style="height: 34px;
                     width: 40px;"></cancelIcon>
             </div>
         </div>
         <div class="AI-interaction-wrapper" ref="AIInteractionScroll">
            <template v-if="AIInteractions.length">
              <AIInteraction @insert-click="insertValueToTextArea" :AIInteractions="AIInteractions" :showInsertButton="showInsertButton"></AIInteraction>
            </template>
            <div v-else class="no-data-container">
              <div class="no-data-icon">
                  <i class="bi bi-inbox"></i>
              </div>
              <div class="no-data-text">No Data Found</div>
            </div>
         </div>
     </div>
    </div>
 </template>
 
 <script>
 import cancelIcon from "../core/InlineCancelField.vue";
 import { mapMutations } from "vuex";
 import AIInteraction from "./AIInteraction.vue";

 export default {
     props: ['AIInteractions','showInsertButton'],
     components:{
         'cancelIcon':cancelIcon,
         AIInteraction
     },
     watch: {
        AIInteractions: {
            handler() {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
            deep: true,
        }
    },
     methods:{
        scrollToBottom() {
            if (this.$refs.AIInteractionScroll) {
                this.$refs.AIInteractionScroll.scrollTop = this.$refs.AIInteractionScroll.scrollHeight;
            }
        },
        insertValueToTextArea(buttonInfo) {
            this.$emit("insert-click", buttonInfo);
        },
        closeAIPanel(){
            this.$emit("close-ai-panel");
        },
        ...mapMutations("miscellaneous",["setAIPanelState"]),
     },
     mounted() {
        this.$nextTick(() => {
            this.scrollToBottom(); // Use the new method
        });
      }
 }
 </script>
 
 <style scoped lang="scss">
 $table-row-border: none;
 $secondary-blue-color: #00a1ff;
 $danger-color: #dc3545;
 $none-text-color:#4f4f4f;
 $add-button-text-color:#0b7099;
 $add-button-text-color-hover:#0193cc;
 $add-button-border-color:#b7b228;
 $add-button-border-on-hover:#dcd426;
 $add-button-backgroud:#1e1e1e;
 $active-green-color:#28a745;
 $primary-background: #1a1e21;
 $border-color: 1px solid #4a4a4a;
 $primary-background: #1a1e21;
 $secondary-background-color:#15181B;
 $bg-color-on-hover: #22272b;
 $text-color: #eee;
 $dull-text-color: #757575;
 $secondary-text-color: #9c9c9c;
 $active-blue : #007bff;
 $input-field-and-label-font-size:14px;
 $input-field-height:38px;
 $highlight-font-color:#ff9800;
 $scrollbar-thumb-background:#333;
 $scrollbar-track-background:#1a1e21;
 $scrollbar-thumb-on-hover-background:#555; 
 $filter-border-color: #5a5a5a;
 $filter-bg-color: #2a2a2a;
 $learn-about-text-color-hover:#b7b327;
 $learn-about-text-color:#9a9620;
 $tags-background-color:#282d31;
 $svg-color:#666;
 $tags-border-color:#363636;
 $secondary-border-color: 1px solid #2b2b2b;
 $icon-hover:#2c3339;
 $count-bg-color:#e7c20b;
 $brighter-border: 1px solid #5a5a5a;
 $input-field-padding:.375rem 10px;
 $tag-color: #18a6db;
 $count-border-color:#373737;

 .no-data-container {
  text-align: center;
  border-radius: 12px;
  padding: 50px 40px;
  max-width: 400px;
  width: 100%;
}

.no-data-icon {
  color: #007bff8f;
  i{
    font-size: 34px;
  }
}

.no-data-text {
  color: $dull-text-color;
  font-size: 14px;
  margin-bottom: 10px;
}
 
 .active{
     color:$active-blue;
 }
 
 .dull-text-display{
     color:$dull-text-color !important;
     font-size: 12px;
 }
 
 .filters-bar{
     max-height: 190px;
     width: 100%;
     overflow:auto;
     display:inline-block;
     ul{
         list-style-type: none;
         padding-inline-start:2px;
         li{
             text-align: start;
             margin-inline-start: 6%;
             margin-top: 9px;
         }
     }
 }
 
 .notification-panel-wrapper{
     width: 450px;
     border: 1px solid #3a3a3a;
     position: absolute;
     background: $secondary-background-color;
     bottom: 1px !important;
     top:unset !important;
     inset-inline-end: 1px;
     z-index: 9999999999;
     height: 100%;
     box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
     -webkit-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
     -moz-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
     .close-or-min-panel{
             height: 65px;
             width:100%;
             border-bottom: $secondary-border-color;
             background: $secondary-background-color;
             text-align: end;
             padding: 5px;
             display: flex;
             justify-content: space-between;
         }
         .configuration-panel{
             height: 40px;
             width:100%;
             background: $secondary-background-color;
             text-align: end;
             padding: 5px;
             display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: baseline;
            gap: 26px;
             .learn-about-text-styles{
                 padding-top:5px;
             }
         }
     .notification-display-wrapper{
             height:83%;
             width: 100%;
             padding-top: 7px;
             overflow:auto;
             display:inline-block;
             .edit-upload-info{
                 width:8%;
                 padding: 5px;
                     svg{
                         position: relative;
                         inset-inline-end: 6px;
                     }
             }
             .file-name-with-progress-bar-wrapper{
                     display: inline-flex;
                     width: 93%;
                     .file-name-wrapper{
                         width: 99%;
                         display: inline-block;
                         .file-name-display{
                             text-align: start;
                             /* white-space: nowrap; */
                             overflow-wrap: break-word;
                             width: 277px;
                             /* overflow: hidden; */
                             /* text-overflow: ellipsis;*/
                             span{
                                     font-size: 11px;
                                     color: #dbdbdb;
                             }
                         }
                         .upload-status-text{
                             text-align: start;
                             float:inline-start;
                             font-size:11px;
                             margin-inline-start:8px;
                             color:#8d8d8d;
                         }
                         .progress-bar-wrapper{
                                 display: inline-flex;
                                 width: 100%;
                                 .progress-percentage-display{
                                         font-size: 11px;
                                 }
                                 .progress{
                                     width: 67%;
                                     background: #292929;
                                     margin-inline-start: 4px;
                                     height: 10px;
                                     margin-top: 2px;
                                     border-radius: 3px;
                                 }
                                 .progress-speed-display{
                                         font-size: 11px;
                                         margin-inline-start: 3px;
                                 }
                         }
                     }
                 }
                 .file-upload-status-display-wrapper{
                         width:20%;
                         .file-upload-status{
                             height: 30px;
                             margin-top: 8px;
                             display:inline-flex;
                         }
                     }
             }
         }
 
 
 .notification-configuration{
     visibility: hidden;
     position: relative;
     inset-inline-end: 4px;
     bottom: 3px;
 }
 
 .close-or-min-panel:hover{
     .notification-configuration{
         visibility: visible;
         position: relative;
         inset-inline-end: 4px;
         bottom: 3px;
     }
 }
 
 .scroll-bottom-btn{
    position:sticky;
    border-radius: 20px;
    margin: auto;
    bottom: -3px;
    width: 100%;
    display: flex;
    justify-content: center;
    button{
      padding: 5px;
      width: 35px;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      background: $secondary-background-color;
      opacity: 0.8;
    }
  }

  .scroll-bottom-btn:hover {
    button{
      opacity: 1;
      background: $bg-color-on-hover;
    }
    svg{
      fill: $text-color;
      color: $text-color;
    }
  }

  .progress-container {
    position: relative;
    width: 100%;
    height: 24px;
    background-color: #2b2b2b;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 8px;
  }
  
  .progress-bar {
    height: 100%;
    background-color: #007bff;
    width: 0%;
    transition: width 0.03s linear;
  }
  
  .progress-text {
    position: absolute;
    width: 100%;
    text-align: center;
    line-height: 24px;
    color: #eee;
    font-size: 14px;
  }

  .AI-interaction-wrapper{
      padding: 12px;
      height: 89% !important;
      overflow: auto !important;
      .input-interaction-wrapper{
        margin-inline-start: 26px;
        text-align: start;
        margin-bottom: 14px;
        white-space: pre-wrap;
        word-break: break-word;
        border: 1px solid #3a3a3a;
        border-radius: 15px;
        padding: 9px;
        background: #1e2022;
        user-select: text;
        cursor: auto;
      }
      .output-interaction-wrapper{
        text-align: start;
        white-space: pre-wrap;
        word-break: break-word;
        border-radius: 15px;
        padding: 11px;
        user-select: text;
        cursor: auto;
        height: calc(100% - 53px);
        overflow: auto;
        padding-bottom: 0px;
        display: flex;
        flex-direction: column;  
        span{
          color: $secondary-text-color;
          margin-bottom: 7px;
        }        
      }
      .interaction-buttons{
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 13px;
        margin-inline-start:10px;
        span:hover{
          text-decoration: underline;
        }
      }
    }
    
    .truncated-text-wrapper {
      white-space: pre-wrap; // preserve line breaks
    }
    
    .load-more {
      display: inline;       // important: inline so it stays next to text
      margin-inline-start: 4px;      // optional spacing
      cursor: pointer;
      color: $secondary-text-color;
      font-weight: 500;
      &:hover {
        opacity: 0.8;
      }
    }

    .interaction-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      padding: 6px;
      border-radius: 4px;
      transition: background 0.2s;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap:4px;
    }

    .ai-thinking {
      display: flex;
      align-items: center;
      gap: 15px;
      padding: 4px;
      border-radius: 10px;
      margin-bottom: 10px;
      justify-content: flex-start;
      span {
        color: $secondary-text-color;
        font-size: 14px;
      }
    }

    .typing-dots {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
  }

  .shimmer {
      background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.3) 0%,
          rgba(255, 255, 255, 0.8) 50%,
          rgba(255, 255, 255, 0.3) 100%
      );
      background-size: 200% 100%;
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: shimmer 4s ease-in-out infinite;
      font-weight: 600;
      font-size: 16px;
  }

  @keyframes shimmer {
      0% {
          background-position: 200% 0;
      }
      100% {
          background-position: -200% 0;
      }
  }
  .button-name-display{
    text-align: end;
    position: relative;
    bottom:8px;
    background: #d1d2d31a;
    width:fit-content;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9px;
    inset-inline-end: 0px;
    padding:10px;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

 </style>
 
 
 
 